import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../healthpicks.constants';

@Component({
  selector: 'app-healthpicks-change-password-sent',
  templateUrl: './healthpicks-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    '../style/hp-shared.css',
    './healthpicks-change-password-sent.component.css',
  ],
})
export class HealthpicksChangePasswordSentComponent implements OnInit {
  email: string | null;

  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}

  returnToList(): void {
    history.back();
  }
}
